module.exports = __webpack_public_path__ + "img/nocontent.ecd62c8a.png";